import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useRef, useState } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import ImageCard from "../../components/card/ImageCard";
import FormItemInputTextarea from "../../components/form-item/form-item-input-textarea";
import FormButton from "../../components/FormButton";
import FormItemInputNumber from "../../components/form-item/form-item-input-number";
import "quill/dist/quill.snow.css";
import VideoCard from "../../components/card/VideoCard";
import MediaPreview from "../../components/MediaPreview";
import { $api } from "../../helper";
import {
  GetFullMediaPath,
  numberFormatter,
  requireRules,
} from "../../helper/method";
import {
  language_choices,
  statusShowMock,
  tokenMock,
  typeMock,
} from "../../helper/mock";
import PreviewFile from "../../components/PreviewFile";
import { useNavigate, useSearchParams } from "react-router";
import { useNotify } from "../../helper/notify";
import Quill from "quill";
import type { valueType } from "antd/es/statistic/utils";

export default function AddCourses() {
  const { data } = $api.useQuery("get", "/site-api/v1/course-form/");
  const courseLevel = $api.useMutation(
    "get",
    "/site-api/v1/course-level-form/",
  );
  const addCourse = $api.useMutation("post", "/site-api/v1/course/");
  const updateCourse = $api.useMutation("put", "/site-api/v1/course/");
  const detailCourse = $api.useMutation("get", "/site-api/v1/course-detail/");
  const [filterType, setFilterType] = useState(1);
  const [department_u_id, setDepartment_u_id] = useState("");
  const [stage_u_id, setStage_u_id] = useState("");
  const editorRef = useRef<HTMLDivElement | null>(null);
  const quillRef = useRef<Quill | null>(null);
  const [type, setType] = useState("1");
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const notify = useNotify();
  const [price, setPrice] = useState<number | null>(0);
  const navigate = useNavigate();
  const [prerequisites, setPrerequisites] = useState<
    {
      value: string;
      type: number;
    }[]
  >([]);
  const [file, setFile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const [fileVideo, setFileVideo] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ایجاد دوره جدید");
    form.setFieldValue("type", type);
    if (searchParams.get("u_id")) {
      detailCourse.mutate({
        params: {
          query: {
            course_u_id: searchParams.get("u_id") ?? "",
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (!editorRef.current) return;

    if (quillRef.current) return;

    quillRef.current = new Quill(editorRef.current, {
      theme: "snow",
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ color: [] }, { background: [] }],
          [{ direction: "rtl" }],
          [{ align: [] }],
          ["link"],
          ["clean"],
        ],
      },
    });
  }, []);

  useEffect(() => {
    if (detailCourse.data) {
      Object.entries(detailCourse.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
      setType(detailCourse.data.data.type.toString());
      setFile([
        {
          file: undefined,
          fileUrl: GetFullMediaPath(detailCourse.data.data.image),
          id: detailCourse.data.data.u_id,
        },
      ]);
      setFileVideo([
        {
          file: undefined,
          fileUrl: GetFullMediaPath(detailCourse.data.data.preview),
          id: detailCourse.data.data.u_id,
        },
      ]);
      setPrice(detailCourse.data.data.price);
      form.setFieldValue(
        "prerequisite_list",
        detailCourse.data?.data.prerequisite_list?.map((e) => e.value),
      );
      setDepartment_u_id(detailCourse.data?.data.department_u_id ?? "");
      setStage_u_id(detailCourse.data?.data?.stage_u_id ?? "");
      setFilterType(3);
      setPrerequisites(detailCourse.data?.data.prerequisite_list);
      quillRef.current?.clipboard.dangerouslyPasteHTML(
        detailCourse.data.data.full_description,
      );
    }
  }, [detailCourse.data, form]);

  useEffect(() => {
    courseLevel.mutate({
      params: {
        query: {
          filter_type: filterType,
          department_u_id,
          stage_u_id,
        },
      },
      headers: {
        Authorization: tokenMock,
        lang: "fa",
      },
    });
  }, [department_u_id, filterType, stage_u_id]);

  useEffect(() => {
    if (quillRef.current) {
      quillRef.current.format("align", "right");
      quillRef.current.on("text-change", () => {
        form.setFieldValue(
          "full_description",
          Number(quillRef.current?.editor.delta.ops[0].insert?.length) <= 1
            ? ""
            : quillRef.current && quillRef.current.root.innerHTML,
        );
      });
    }
  }, [quillRef.current?.editor.getText]);

  const onFinish = (
    values: {
      title: string;
      status: string;
      category_u_id: string;
      prerequisite: string;
      type: string;
      price: string;
      short_description: string;
      full_description: string;
      seo_title: string;
      seo_description: string;
      language: string;
      attribute_u_id: string;
      level_u_id: string;
      teacher_u_id: string;
      slug: string;
      price_with_discount?: string;
    },
    redirect = true,
  ) => {
    const formData = new FormData();
    if (searchParams.get("u_id")) {
      formData.append("course_u_id", searchParams.get("u_id") ?? "");
    }
    formData.append("category_u_id", values.category_u_id);
    formData.append("full_description", values.full_description);
    formData.append("prerequisite", values.prerequisite);
    formData.append("language", values.language);
    formData.append("attribute_u_id", values.attribute_u_id);
    formData.append("slug", values.slug);
    if (values.type === "2") {
      formData.append("teacher_u_id", values.teacher_u_id ?? "");
    }
    formData.append("level_u_id", values.level_u_id);
    formData.append("department_u_id", department_u_id);
    formData.append("stage_u_id", stage_u_id);
    formData.append("prerequisite_list", JSON.stringify(prerequisites));
    formData.append("price", values.price);
    if (values.price_with_discount)
      formData.append("price_with_discount", values.price_with_discount);
    formData.append("seo_description", values.seo_description);
    formData.append("seo_title", values.seo_title);
    formData.append("short_description", values.short_description);
    formData.append("status", values.status);
    formData.append("title", values.title);
    formData.append("type", values.type);
    file.forEach((element) => {
      formData.append("image", element.file ?? element.fileUrl);
    });
    fileVideo.forEach((element) => {
      formData.append("preview", element.file ?? element.fileUrl);
    });
    if (searchParams.get("u_id")) {
      updateCourse.mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/courses");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      addCourse.mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/courses");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e, true)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <CustomBreadcrumb
        items={[
          {
            title: "لیست دوره ها",
            href: "/courses",
          },
          {
            title: "ایجاد دوره جدید",
          },
        ]}
      />
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به دوره"
        title="اطلاعات اصلی دوره"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInputSelect
            className="col-span-1"
            name={"type"}
            rules={requireRules("نوع مشاهده دوره")}
            label="نوع مشاهده"
            inputProps={{
              placeholder: "لطفا نوع مشاهده خود را انتخاب کنید.",
              options: typeMock?.map((e) => ({
                label: e.label,
                value: e.value.toString(),
              })),
              onChange: (e) => {
                setType(e);
              },
              value: type,
            }}
          />
          <FormItemInput
            name={"title"}
            rules={requireRules("عنوان دوره")}
            className="col-span-1"
            label="عنوان دوره"
            inputProps={{
              placeholder: "لطفا عنوان دوره خود را وارد کنید.",
            }}
          />
          <FormItemInput
            name={"slug"}
            rules={requireRules("اسلاگ")}
            className="col-span-1"
            label="اسلاگ"
            inputProps={{
              placeholder: "لطفا اسلاگ خود را وارد کنید.",
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            name={"status"}
            rules={requireRules("وضعیت دوره")}
            label="وضعیت"
            inputProps={{
              placeholder: "لطفا وضعیت نمایش دوره خود را انتخاب کنید.",
              options: statusShowMock,
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            name={"attribute_u_id"}
            rules={requireRules("ویژگی دوره")}
            label="ویژگی ها"
            inputProps={{
              placeholder: "لطفا وضعیت نمایش دوره خود را انتخاب کنید.",
              options: data?.data.attributes?.map((e) => ({
                label: e.title,
                value: e.u_id,
              })),
              mode: "multiple",
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            name={"category_u_id"}
            rules={requireRules("دسته بندی دوره")}
            label="دسته بندی"
            inputProps={{
              placeholder: "لطفا دسته بندی دوره خود را انتخاب کنید.",
              options: data?.data.categories?.map((e) => ({
                label: e.title,
                value: e.u_id,
              })),
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            name={"language"}
            rules={requireRules("زبان دوره")}
            label="زبان دوره"
            inputProps={{
              placeholder: "لطفا زبان دوره خود را انتخاب کنید.",
              options: language_choices?.map((e) => ({
                label: e.label,
                value: e.value.toString(),
              })),
            }}
          />
          {type === "2" ? (
            <FormItemInputSelect
              className="col-span-1"
              name={"teacher_u_id"}
              rules={requireRules("مدرس دوره")}
              label="مدرس"
              inputProps={{
                placeholder: "لطفا مدرس دوره خود را انتخاب کنید.",
                options: data?.data?.teachers?.map((e) => ({
                  label: e.title,
                  value: e.u_id,
                })),
              }}
            />
          ) : (
            ""
          )}
          <FormItemInputSelect
            className="col-span-1"
            name={"prerequisite_list"}
            help="میتوانید مورد دلخواه خود را هم اضافه کنید"
            label="پیش نیاز های دوره"
            inputProps={{
              placeholder: "لطفا پیش نیاز های خود را انتخاب کنید.",
              options: data?.data.courses.map((e) => ({
                label: e.title,
                value: e.u_id,
              })),
              mode: "tags",
              onChange: (value: string[]) => {
                const formatted = value.map((item) => ({
                  value: item,
                  type: data?.data?.courses?.some((e) => e.u_id === item)
                    ? 1
                    : 2,
                }));
                setPrerequisites(formatted);
              },
            }}
          />
          <FormItemInputNumber
            className="col-span-1 w-full"
            name={"price"}
            rules={requireRules("قیمت دوره")}
            label="قیمت"
            inputProps={{
              placeholder: "قیمت دوره را وارد کنید",
              onChange: (e: valueType | null) => {
                setPrice(Number(e ?? 0));
                form.resetFields(["price_with_discount"]);
              },
            }}
          />
          <FormItemInputNumber
            className="col-span-1 w-full"
            name={"price_with_discount"}
            label="قیمت دوره با تخفیف"
            rules={[
              {
                validator(_, value) {
                  if (!value) return Promise.resolve();
                  if (Number(value) >= (price ?? 0)) {
                    return Promise.reject(
                      new Error(
                        `مقدار تخفیف باید کمتر از ${numberFormatter(price ?? 0)} باشد`,
                      ),
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
            inputProps={{
              placeholder: "قیمت دوره با تخفیف را وارد کنید",
              disabled: price ? false : true,
            }}
          />
          {/* department */}
          <div className="col-span-2 grid grid-cols-3 gap-6">
            <FormItemInputSelect
              className="col-span-1"
              name={"department_u_id"}
              rules={requireRules("دپارتمان")}
              label="دپارتمان ها"
              inputProps={{
                placeholder: "لطفا دپارتمان خود را انتخاب کنید.",
                options: courseLevel.data?.data.departments_list?.map((e) => ({
                  label: e.name,
                  value: e.u_id,
                })),
                onChange: (e) => {
                  setDepartment_u_id(e);
                  setFilterType(2);
                  form.resetFields(["stage_u_id", "level_u_id"]);
                },
              }}
            />
            <FormItemInputSelect
              className="col-span-1"
              name={"stage_u_id"}
              rules={requireRules("مقطع")}
              label="مقطع"
              inputProps={{
                placeholder: "لطفا مقطع خود را انتخاب کنید.",
                options: courseLevel.data?.data.stages_list?.map((e) => ({
                  label: e.name,
                  value: e.u_id,
                })),
                onChange: (e) => {
                  setStage_u_id(e);
                  setFilterType(3);
                  form.resetFields(["level_u_id"]);
                },
              }}
            />
            <FormItemInputSelect
              className="col-span-1"
              name={"level_u_id"}
              rules={requireRules("سطح دوره")}
              label="سطح دوره"
              inputProps={{
                placeholder: "لطفا سطح دوره خود را انتخاب کنید.",
                options: courseLevel.data?.data.levels_list?.map((e) => ({
                  label: e.name,
                  value: e.u_id,
                })),
                onChange: () => {
                  // setFilterType(3)
                },
              }}
            />
          </div>
        </div>
      </FormCard>
      <FormCard subTitle="توضیح کوتاه و کامل دوره" title="توضیحات دوره">
        <div className="grid grid-cols-2 w-full gap-6">
          <FormItemInputTextarea
            name={"short_description"}
            rules={requireRules("توضیحات کوتاه دوره")}
            className="col-span-2"
            label="توضیحات کوتاه"
            inputProps={{
              placeholder: "توضیحات مختصر...",
              rows: 8,
            }}
          />
          <div className="col-span-2">
            <Form.Item
              rules={requireRules("توضیحات کامل دوره")}
              name={"full_description"}
              label="توضیحات کامل"
            >
              <div
                dir="auto"
                className="w-full border-r border-l border-b border-grayscale-200 h-96! rounded-br-xl rounded-bl-xl"
                lang="fa"
                ref={editorRef}
              />
            </Form.Item>
          </div>
        </div>
      </FormCard>
      <FormCard subTitle="تصویر مربوط به نمایش دوره" title="تصویر دوره">
        <div className="flex w-full gap-6 flex-col">
          <div className="w-full">
            <ImageCard
              multiple={false}
              setFile={setFile}
              file={file}
              id="image1"
              name="image1"
            />
          </div>
          <div className="grid-cols-8 grid gap-6">
            {file?.map((e, i) => (
              <div className="col-span-1 aspect-square">
                <PreviewFile
                  setFile={setFile}
                  url={e.fileUrl}
                  id={e.id}
                  key={i + e.id}
                />
              </div>
            ))}
          </div>
        </div>
      </FormCard>
      <FormCard subTitle="پیش نمایش مربوط به نمایش دوره" title="پیش نمایش دوره">
        <div className="flex w-full gap-6 flex-col">
          <div className="w-full">
            <VideoCard
              multiple={false}
              title="ویدیو یا تصویر مربوط را انتخاب کنید"
              setFile={setFileVideo}
              file={fileVideo}
              image={true}
              inputProps={{
                multiple: true,
              }}
              id="preview-1"
              name="preview"
            />
          </div>
          <div className="grid-cols-8 grid gap-6">
            {fileVideo?.map((e, i) => (
              <MediaPreview
                type={e.file?.type?.startsWith("image/") ? "image" : "video"}
                id={e.id}
                mediaUrl={e.fileUrl}
                setFile={setFileVideo}
                key={i + e.id}
              />
            ))}
          </div>
        </div>
      </FormCard>
      <FormCard
        title="اطلاعات سئو"
        subTitle="بهینه‌سازی دوره برای موتورهای جستجو"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            label="عنوان سئو"
            name={"seo_title"}
            rules={requireRules("عنوان سئو")}
            className="col-span-1"
            inputProps={{
              placeholder: "لطفا عنوان سئو خود را وارد کنید.",
            }}
          />
          <FormItemInputTextarea
            label="توضیحات"
            name={"seo_description"}
            rules={requireRules("توضیحات سئو")}
            className="col-span-1"
            inputProps={{
              className: "resize-none!",
              rows: 4,
              placeholder: "لطفا توضیحات اضافی سئو خود را بنویسید...",
            }}
          />
        </div>
      </FormCard>
      <FormButton
        isPending={addCourse.isPending || updateCourse.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
